import * as constants from "../constants";
import type { BoundingClientRect } from "../flip/getFlippedElementPositions/types";
import { toArray } from "../../../../utils/to";

/** @deprecated */
export const getAllElements = (element: HTMLElement): HTMLElement[] => {
	return toArray(element.querySelectorAll(`[${constants.DATA_FLIP_ID}]`));
};

export const getRects = (elements: HTMLElement[]): [HTMLElement, BoundingClientRect][] => {
	return elements.map((el) => [el, el.getBoundingClientRect()]);
};
